import { Component, OnInit, ViewChild, TemplateRef, Input } from '@angular/core';
import { IEpGridModel, IEpGridSelectionOptions, IEpGridColumn } from '@epicor/kinetic';
import { IEpBtFaCardModel } from '../../models/epbt-fa-card.model';
import { DateFormats, ModelType, GridFieldType, DocumentTypes } from 'ep-bt-controls';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { EpbtFaDocumentDetailService } from '../../services/epbt-fa-document-detail.service';
declare var $: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-document-line',
  templateUrl: './epbt-fa-document-line.component.html',
  styleUrls: ['./epbt-fa-document-line.component.scss']
})
export class EpbtFaDocumentLineComponent implements OnInit {

  @ViewChild('dateTemplate', { static: false }) dateTemplate: TemplateRef<any>;
  @ViewChild('dateTimeTemplate', { static: false }) dateTimeTemplate: TemplateRef<any>;
  @ViewChild('timeTemplate', { static: false }) timeTemplate: TemplateRef<any>;
  @ViewChild('currencyTemplate', { static: true }) currencyTemplate: TemplateRef<any>;
  @ViewChild('currencyWithCodeTemplate', { static: true }) currencyWithCodeTemplate: TemplateRef<any>;
  @ViewChild('numericTemplate', { static: true }) numericTemplate: TemplateRef<any>;
  @ViewChild('numericWithCodeTemplate', { static: true }) numericWithCodeTemplate: TemplateRef<any>;
  @ViewChild('percentageTemplate', { static: true }) percentageTemplate: TemplateRef<any>;

  public gridModel: IEpGridModel;
  public pageSize = 10;

  card: Array<IEpBtFaCardModel>;
  documents: any = [];
  currency: string;
  dateFormat: any = DateFormats;
  gridColumns: IEpGridColumn[];
  documetTypes: any = DocumentTypes;

  @Input() documentType: string;
  @Input() lines: any = [];

  constructor(private fieldAgentService: EpbtFieldAgentService, private faDocumentService: EpbtFaDocumentDetailService) { }

  ngOnInit() {
    // var bistrackSettings = this.fieldAgentService.getBisTrackSetting();
    // this.currency = bistrackSettings.baseCurrency.symbol;
    // this.dateFormat.ShortDate = bistrackSettings.shortDateFormat ? bistrackSettings.shortDateFormat : DateFormats.ShortDate;

    this.fieldAgentService.getBisTrackSetting((bistrackSettings: any) => {
      this.currency = bistrackSettings.baseCurrency.symbol;
      this.dateFormat.ShortDate = bistrackSettings.shortDateFormat ? bistrackSettings.shortDateFormat : DateFormats.ShortDate;
    });

    console.log(this.lines);
    console.log(this.documentType);
    this.card = this.faDocumentService.generateGridModelIEpGridColumn(this.documentType, ModelType.CardModel);
    this.gridModel = this.getGridModel();
    this.gridModel.data = this.lines;
    this.documents = this.lines;
  }

  getGridModel(): IEpGridModel {
    this.gridColumns = [];
    const selectionOptions: IEpGridSelectionOptions = {
      selectByField: '',
      selectedKeys: [],
    };

    this.faDocumentService.generateGridModelIEpGridColumn(this.documentType, ModelType.GridModel).forEach(element => {
      const row: IEpGridColumn = {
        field: element.field,
        title: element.title,
        width: element.width,
        hidden: element.hidden,
        editor: element.editor,
        cellTemplate: this.getTemplateType(element.type)
      };
      this.gridColumns.push(row);
    });

    const model: IEpGridModel = {
      resizable: false,
      reorderable: false,
      groupable: false,
      filterable: false,
      pageable: false,
      // pageSize: this.pageSize,
      scrollable: 'scrollable',
      rowHeight: 20,
      sortable: true,
      selectionOptions: selectionOptions,
      data: this.documents,
      columns: this.gridColumns,
    };
    return model;
  }

  getHeight(): number {
    const height = parseInt($('body').height());

    if (height > 900) {
      // return 300;
      return 700;
    } else { return 500; }// return 500;
  }

  // card model
  getList(model) {
    const data = [];
    if (model) {
      const list = Object.keys(model);
      if (this.card) {
        this.card.filter(i => {
          list.filter(k => {
            if (k == i.field) {
              data.push({
                key: i.displayName, value: model[i.field],
                icon: i.icon, isStatus: i.isStatus, isTitle: i.isTitle, isSubTitle: i.isSubTitle,
                isDate: i.isDate, isDateWithTime: i.isDateWithTime, isTime: i.isTime,
                isCurrency: i.isCurrency, isCurrencyWithCode: i.isCurrencyWithCode,
                isNumeric: i.isNumeric, isNumericWithCode: i.isNumericWithCode,
                isPercentage: i.isPercentage
              });
            }
          });
        });
      }
    }
    return data;
  }

  // Template Type

  getTemplateType(type: any): TemplateRef<any> {
    switch (type) {
      case GridFieldType.Date: return this.dateTemplate;
      case GridFieldType.DateTime: return this.dateTimeTemplate;
      case GridFieldType.Time: return this.timeTemplate;
      case GridFieldType.Currency: return this.currencyTemplate;
      case GridFieldType.CurrencyWithCode: return this.currencyWithCodeTemplate;
      case GridFieldType.Numeric: return this.numericTemplate;
      case GridFieldType.NumericWithCode: return this.numericWithCodeTemplate;
      case GridFieldType.Percentage: return this.percentageTemplate;
      default: return null;
    }
  }

}
